(function ($, Global) {
    var urlParams = new UrlParams();
    var params = urlParams.getParams();
    var HeaderComponent = function () {
        // D�claration class objet
    }

    HeaderComponent.prototype.initEvents = function () {
        this.subscribers();
        this.publishers();
    }

    HeaderComponent.prototype.publishers = function () {
        var self = this;
        $(document).ready(function () {
            if (params['edition']) self.updateEditionSelector(params['edition']);
        });
        $(document).on('click', 'header .dropdown-menu', function (e) {
            e.stopPropagation();
        });
        $(document).on('show.bs.dropdown', '.header-row-1 .logo-mobile', function () {
            self.handleSelectPublication.apply(this);
        });
        $(document).on('hide.bs.dropdown', '.header-row-1 .logo-mobile', function () {
            self.handleSelectPublication.apply(this);
        });
        $(document).on('shown.bs.dropdown', '.header-row-3 .search-wrapper', function () {
            $(this).find('[name="searchquerry"]').focus();
        });
        $(document).on('click', '.header-row-1 [data-toggle="menuLeft"]', function (e) {
            e.preventDefault();
        });
        
        $(document).on('change', '.header-row-1 select', function (e) {
            var value = $(this).val();
            var prefix = '';

            var localPathName = window.location.pathname.toLowerCase();
            if (localPathName == '/fr' || localPathName.startsWith('/fr/')) prefix = "/fr";
            if (localPathName == '/en' || localPathName.startsWith('/en/')) prefix = "/en";

            var isArchive = $('#DateEdition').find('.item[value="' + params['edition'] + '"]').first().data('is-archive');
            $(document).find('.ga-edition-link').attr('href', prefix + (isArchive ? '/archives?Issue=' : '/daily/#/article/') + value)
            $.Topic('carousel-unes-changed').publish(value);
        });
        $(document).on('show.bs.dropdown', 'header', function (e) {
            $('header').addClass('show');
            $('.screen-backdrop').addClass('in');
        });
        $(document).on('hidden.bs.dropdown', 'header', function () {
            $('header').removeClass('show');
            $('.screen-backdrop').removeClass('in');
            $('header .dropdown-toggle').each(function () {
                $(this).dropdown('hide')
            });
        });
        $(document).on('click', '.dropdown .close', function (e) {
            $('header').removeClass('show');
            $('.screen-backdrop').removeClass('in');
            $('header .dropdown-toggle').each(function () {
                $(this).dropdown('hide')
            });
        });
    }

    HeaderComponent.prototype.subscribers = function () {
        var self = this;
        $.Topic('select-edition').subscribe(function (date, isArchive) {
            if (window.location.pathname !== "/" && window.location.pathname !== "/fr" && window.location.pathname !== "/en") {
                var redirectPath = '/' + '?edition=' + date + '&archive=' + isArchive;

                if (window.location.pathname.slice(0, 3) == '/fr') redirectPath = "/fr" + redirectPath;
                if (window.location.pathname.slice(0, 3) == '/en') redirectPath = "/en" + redirectPath;

                window.location.replace(redirectPath);
            } else {
                urlParams.setParam("edition", date);
                $.Topic('change-edition').publish(date, isArchive);
                self.updateEditionSelector(date);
                $('.dropdown.show #editionSelected').dropdown('toggle');
            }
        });
    }

    HeaderComponent.prototype.updateEditionHeading = function (date) {
        var $dateLink = $('.edition-selection [value="' + date + '"]');
        if (!$dateLink.exists()) return;
        var heading = $dateLink.data('date-text');
        $(document).find('#editionSelected span').html(heading);
        $(document).find('.headerFrontPage #editionSelected .date-selected').html(heading);
    }

    HeaderComponent.prototype.updateEditionSelector = function (date) {
        this.updateEditionHeading(date);
        $(document).find('#DateEdition .active').removeClass('active');
        $(document).find('#DateEdition .item[value="' + date + '"]').addClass('active');
    }

    HeaderComponent.prototype.handleSelectPublication = function () {
        var $this = $(this);
        var $icon = $this.find('.icon');

        $icon.toggleIconClass('icon-544', 'icon-54');
    };

    Global.HeaderComponent = HeaderComponent;
}(jQuery, window));